module.exports = __webpack_public_path__ + "img/upload-icon.e649ecd7.svg";